// app-user · app shell strings (root layout): the notice when the server ends a session
// and the root error screen (rendered outside the providers, so it formats these with
// the last app language). Spread into en.ts / bn.ts.
export const appEnShell = {
  'app.shell.sessionExpired': 'You were signed out. Sign in again to continue.',
  'app.shell.error.title': 'Something went wrong',
  'app.shell.error.body': 'The app ran into a problem. Restart it to carry on — your bookings are safe.',
  'app.shell.error.restart': 'Restart',
} as const satisfies Record<string, string>;

export const appBnShell = {
  'app.shell.sessionExpired': 'আপনি সাইন আউট হয়ে গেছেন। চালিয়ে যেতে আবার সাইন ইন করুন।',
  'app.shell.error.title': 'কিছু একটা সমস্যা হয়েছে',
  'app.shell.error.body': 'অ্যাপে একটি সমস্যা হয়েছে। চালিয়ে যেতে আবার চালু করুন — আপনার বুকিং নিরাপদ আছে।',
  'app.shell.error.restart': 'আবার চালু করুন',
} as const satisfies Record<keyof typeof appEnShell, string>;
